import {Component, ElementRef, HostListener, Inject, LOCALE_ID, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {Router} from '@angular/router';
import {CommonComponent} from '../shared/common/common.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../services/notifications.service';
import {ToastaService} from 'ngx-toasta';
import {LocalStorageService} from 'angular-2-local-storage';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {environment} from '../../../environments/environment';
import {CustomerDetailService} from '../../services/customer-detail.service';
import {CustomerDetail, CustomerStatus} from '../../domain/customer/customer-detail';
import {CustomerProfileService} from '../../services/customer-profile.service';
import {CustomerProfile} from '../../domain/customer/customer-profile';
import {AccountService} from '../../services/account.service';
import {AccountConfiguration, ApplicationConfiguration} from '../../domain/configurations';
import {ConfigurationService} from '../../services/configuration.service';
import {mergeMap, takeUntil} from 'rxjs/operators';
import {of, ReplaySubject} from 'rxjs';
import {Profile} from '../../domain/authentication/profile';
import {StorageItem} from '../../enums/storage-item';
import {DialogService} from 'primeng/dynamicdialog';
import {ECommissionSchemeType} from '../../enums/ECommissionSchemeType';
import {ApplicationStatus} from '../../domain/onBoarding/application-body';
import {Clipboard} from '@angular/cdk/clipboard';
import {FamilyHealthService} from '../../services/family-health.service';
import {FamilyHealthStatus} from '../../enums/family-health-status.enum';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css']
})
export class AccountComponent extends CommonComponent implements OnInit, OnDestroy {
  url = environment.homeEndpoint.slice(8);
  es = environment.es;
  urlDoc1: string;
  urlDoc3: string;
  urlDoc4: string;
  urlDoc5: string;
  urlDDA: string;
  title1: string;
  title3: string;
  title4: string;
  title5: string;
  title6: string;
  subtitle1: string;
  subtitle3: string;
  subtitle4: string;
  subtitle5: string;
  subtitle6: string;
  cardActive = false;
  customerDetail: CustomerDetail;
  profileDetail: CustomerProfile;
  configuration: AccountConfiguration;
  // BrokerEnabled
  eCommissionSchemeType = ECommissionSchemeType;
  // Pin
  oldPin: string;
  pin: string;
  confirmPin: string;
  cvd: string;
  applicationConfiguration: ApplicationConfiguration;
  // Modal visible
  showReferrerModal = false;
  showReferrerCode = false;
  ApplicationStatus = ApplicationStatus;
  applicationStatus: string;
  // Values to show NIP
  showNewNip = false;
  confirmNip = false;
  changeNewNip = false;
  changeNewNipDigits = false;
  confirmNewNip = false;
  eFamilyHealthStatus = FamilyHealthStatus;
  webPage = null;
  showCancelFamilyHealth = false;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  contractsData: any;

  constructor(
    @Inject(LOCALE_ID) readonly locale: string,
    private accountService: AccountService,
    private authenticationService: AuthenticationService,
    private localStorage: LocalStorageService,
    private customerDetailService: CustomerDetailService,
    public customerProfileService: CustomerProfileService,
    private configurationService: ConfigurationService,
    protected router: Router,
    private element: ElementRef,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    public translate: TranslateService,
    protected dialogService: DialogService,
    private accountsService: AccountService,
    private clipboard: Clipboard,
    public familyHealthService: FamilyHealthService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);

    this.contractsData = configurationService.home.contractsData;
    this.contractsData = JSON.parse(this.contractsData);

    this.configuration = configurationService.account;
    this.applicationConfiguration = configurationService.application;

    this.locale = this.locale.substring(0, 2);
    translate.addLangs(['es', 'en']);
    translate.setDefaultLang('es');
    const profile: Profile = this.localStorage.get(StorageItem.PROFILE);
    if (profile?.locale) {
      translate.use(this.getValidLanguage(profile.locale.substring(0, 2)));
    } else {
      translate.use(this.getValidLanguage(window.location.pathname.substring(1, 3)));
    }
    translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        const language = this.translate.currentLang === 'en' ? 'en' : 'es';
        this.setDocsUrls(language);
      });
  }

  ngOnInit(): void {
    this.setDocsUrls(this.locale);
    this.configurationService.getPlatformConfig();
    this.getCustomerProfile();
  }
  logout() {
    this.msgReset();
    this.authenticationService.logout();
    this.router.navigate(['/']);
  }

  activationCardHelp() {
    this.router.navigate(['/account/activationCardHelp']);
  }

  changeLanguage(language: string) {
    this.authenticationService.setLocale(language);
    this.translate.use(this.getValidLanguage(language)).subscribe(
      response => {
        if (this.useOldTranslation()) {
          window.location.href = `/${language}${this.getCurrentRoute()}`;
        }
      }
    );
  }

  setLanguage(language: string) {
    this.translate.use(this.getValidLanguage(language));
    this.authenticationService.setLanguage(this.getValidLanguage(language)).subscribe(
      response => {
      }, error => {
        this.msgError(error);
      }
    );
  }

  getCurrentRoute() {
    return this.router.url;
  }

  getCustomerProfile() {
    this.customerProfileService.getInstance();
    this.customerDetailService.getInstance();
    this.customerProfileService.customerProfile$.pipe(takeUntil(this.destroyed$)).pipe(
      mergeMap(
        (response: any) => {
          if (response instanceof HttpErrorResponse) {
            return of(response);
          }
          this.profileDetail = response;
          this.applicationStatus = this.profileDetail.applicationStatus;
          if (response.customerStatus === CustomerStatus.ACTIVE) {
            return this.customerDetailService.customerDetail$.pipe(takeUntil(this.destroyed$));
          } else {
            return of(null);
          }
        }
      )
    ).subscribe(
      response => {
        if (response instanceof HttpErrorResponse) {
          this.authenticationService.logout();
          this.msgError(response);
        }else {
          this.configuration = this.configurationService.account;
          this.contractsData = this.configurationService.home.contractsData;
          this.setDocsUrls(this.locale);
          this.customerDetail = response;
        }
      },
      error => {
        this.authenticationService.logout();
        this.msgError(error);
      }
    );
  }

  getProfileDetail(): CustomerProfile {
    return this.profileDetail;
  }

  navChangeLink(event) {
    const elem = this.element.nativeElement.querySelector('.active');
    if (elem) {
      elem.classList.remove('active');
    }
    event.target.classList.add('active');
  }


  resetPinData() {
    this.pin = null;
    this.oldPin = null;
    this.confirmPin = null;
    this.cvd = null;
  }
  changeNip(){
    this.loadingModalOn();
    this.accountsService.changePin(this.oldPin, this.pin).subscribe(
      (response: any) => {
        this.msgSuccess($localize`PIN cambiado correctamente.`);
        this.resetPinData();
      }, error => {
        this.loadingModalOff();
        this.resetPinData();
        this.msgError(error);
      }
    );
  }

  resetNip(modal: any) {
    modal.dismiss();
    this.loadingModalOn();
    this.accountsService.resetPin(this.pin).subscribe(
      (response: any) => {
        this.msgSuccess($localize`PIN creado correctamente.`);
        this.profileDetail.pinAvailable = true;
        this.resetPinData();
      }, error => {
        this.loadingModalOff();
        this.resetPinData();
        this.msgError(error);
      }
    );
  }
  referFriend() {
    this.router.navigate(['/account/referralCode']);
  }
  showReferrerSettings() {
    this.showReferrerModal = true;
  }
  showReferrerCodeModal() {
    this.showReferrerCode = true;
  }

  copyMyReferralCode(){
    this.clipboard.copy(this.getProfileDetail().altairAgentCode);
    this.msgSuccess(this.translate.instant('accounts.menu.referral-code-copied', {Default: 'Código copiado'}));
  }
  manageCard(){
    this.router.navigate(['/account/balance']);
  }

  setDocsUrls(locale: string) {
    const DOCUMENT_TYPES = [
      { type: 'ID_CONSENT', url: 'urlDoc3', title:'title3', subtitle:'subtitle3'},
      { type: 'SHORT_FORM_AGREEMENT', url: 'urlDoc1', title:'title1', subtitle:'subtitle1' },
      { type: 'PRIVACY_POLICY', url: 'urlDoc5', title:'title5', subtitle:'subtitle5' },
      { type: 'TERMS_AND_CONDITIONS_ACCOUNT', url: 'urlDoc4', title:'title4', subtitle:'subtitle4' },
      { type: 'DEPOSIT_FORM', url: 'urlDDA', title:'title6', subtitle:'subtitle6' }
    ];

    DOCUMENT_TYPES.forEach( (docInfo) => {
      const CONTRACT = this.contractsData?.find( (item: any) => item.type === docInfo.type);
      const PATH = CONTRACT?.path?.[locale];
      const PAGE = CONTRACT?.page?.[locale];
      this[docInfo.title] = CONTRACT?.title?.[locale];
      this[docInfo.subtitle] = CONTRACT?.subtitle?.[locale];
      this[docInfo.url] = PATH && PAGE !== undefined ? `${PATH}#page=${PAGE + 1}` : '';
    });
  }

  cancelFamilyHealth(){
    this.familyHealthService.cancelFamilyHealth().subscribe(
      (response: any) => {
        this.msgSuccess(this.translate.instant('accounts.menu.family-health-cancel-success', {Default: 'Tu servicio de Family Card Health fue cancelado exitosamente'}));
        this.familyHealthService.canceled = true;
      }, error => {
        this.msgError(error);
      }
    );
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.unsubscribe();
  }
}
